"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchableTreeview = void 0;
var React = require("react");
var Form_1 = require("../../Form");
var Lists_1 = require("../../Lists");
var Localization_1 = require("../../Localization");
var Searcher_1 = require("../../Searcher");
var setAnnouncement_1 = require("../../setAnnouncement/setAnnouncement");
var Element_1 = require("./components/Element/Element");
var SearchableTreeview_styles_1 = require("./SearchableTreeview.styles");
var SearchableTreeview = function (_a) {
    var Data = _a.Data, OnChange = _a.OnChange, OnBlur = _a.OnBlur, IsSelectedOnlyMode = _a.IsSelectedOnlyMode, SearchAriaLabel = _a.SearchAriaLabel, SearchPlaceholder = _a.SearchPlaceholder, HeaderAriaLabel = _a.HeaderAriaLabel, SelectedItems = _a.SelectedItems, ShowRequired = _a.ShowRequired, ErrorMessage = _a.ErrorMessage;
    var _b = React.useState(""), searchString = _b[0], setSearchString = _b[1];
    var sayPolitely = setAnnouncement_1.setAnnouncement().sayPolitely;
    React.useEffect(function () {
        if (ErrorMessage) {
            sayPolitely(ErrorMessage);
        }
    }, [ErrorMessage]);
    var inputControl = React.createRef();
    var getInternalDataFromData = function (data, parent) {
        var array = [];
        data.forEach(function (item) {
            var internalDataItem = {
                Caption: item.Caption,
                Children: [],
                Folder: item.Children ? item.Children.length > 0 : false,
                HasSelectedChildren: false,
                IsExpanded: item.IsExpanded,
                IsSelected: SelectedItems.some(function (s) { return s.ID === item.UniqueID; }) || (parent && parent.IsSelected) || item.IsSelected,
                ParentId: parent ? parent.UniqueID : null,
                UniqueID: item.UniqueID,
            };
            if (item.Children) {
                item.Children.forEach(function (child) {
                    var _a;
                    return (_a = internalDataItem.Children).push.apply(_a, getInternalDataFromData([child], internalDataItem));
                });
            }
            array.push(internalDataItem);
        });
        return array;
    };
    var checkHasSelectedChildren = function (item) {
        var children = item.Children;
        if (children) {
            for (var i = 0; i < children.length; i++) {
                if (children[i].IsSelected || checkHasSelectedChildren(children[i])) {
                    return true;
                }
            }
        }
        return false;
    };
    var checkHasAllSelectedChildren = function (item) {
        var children = item.Children;
        if (children) {
            for (var i = 0; i < children.length; i++) {
                if (children[i].Folder) {
                    if (!checkHasAllSelectedChildren(children[i])) {
                        return false;
                    }
                }
                else if (!children[i].IsSelected) {
                    return false;
                }
            }
        }
        return true;
    };
    var updateHasSelectedChildrenMutator = function (array) {
        for (var i = 0; i < array.length; i++) {
            array[i].HasSelectedChildren = checkHasSelectedChildren(array[i]);
            if (array[i].Children) {
                updateHasSelectedChildrenMutator(array[i].Children);
            }
        }
    };
    var updateHasAllSelectedChildrenMutator = function (array) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].Folder) {
                array[i].IsSelected = checkHasAllSelectedChildren(array[i]);
            }
            if (array[i].Children) {
                updateHasAllSelectedChildrenMutator(array[i].Children);
            }
        }
    };
    var updateHasSelectedChildren = function (array) {
        var clone = __spreadArray([], array);
        updateHasSelectedChildrenMutator(clone);
        updateHasAllSelectedChildrenMutator(clone);
        return clone;
    };
    var expandWithSelectedChildrenMutator = function (array) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].Folder && array[i].IsExpanded === undefined) {
                array[i].IsExpanded = array[i].HasSelectedChildren;
            }
            if (array[i].Children) {
                expandWithSelectedChildrenMutator(array[i].Children);
            }
        }
    };
    var _c = React.useState(function () {
        var processedArray = updateHasSelectedChildren(getInternalDataFromData(Data, null));
        expandWithSelectedChildrenMutator(processedArray);
        return processedArray;
    }), mainTreeviewArray = _c[0], setMainTreeviewArray = _c[1];
    var getSelectionsFromTree = function (treeViewArray) {
        var selections = [];
        if (!IsSelectedOnlyMode) { // No selections when ReadOnly mode.
            treeViewArray.forEach(function (o) {
                if (!o.Folder && o.IsSelected) { // if not a folder and selected, add to list.
                    selections = __spreadArray(__spreadArray([], selections), [{ ID: o.UniqueID, Description: o.Caption }]);
                }
                else if (o.Children) {
                    selections = __spreadArray(__spreadArray([], selections), getSelectionsFromTree(o.Children));
                }
            });
        }
        return selections;
    };
    var findElement = function (arrayElement, uniqueID) {
        var found = arrayElement.find(function (o) { return o.UniqueID === uniqueID; });
        if (found) {
            return found;
        }
        for (var i = 0; i < arrayElement.length; i++) {
            if (arrayElement[i].Folder && arrayElement[i].Children) {
                var foundChild = findElement(arrayElement[i].Children, uniqueID);
                if (foundChild) {
                    return foundChild;
                }
            }
        }
        return null;
    };
    var getAllSelections = function () {
        var initialTreeArray = __spreadArray([], getSelectionsFromTree(mainTreeviewArray)); // combine selections from the tree, and the SelectedItems
        var selections = [];
        SelectedItems.forEach(function (i) {
            var sElement = findElement(mainTreeviewArray, i.ID); // Make sure first that the id we want to select exist in the tree.
            if (sElement) {
                var isExist_1 = false;
                initialTreeArray.forEach(function (it) {
                    if (i.ID === it.ID) {
                        isExist_1 = true;
                    }
                });
                if (!isExist_1) {
                    selections = __spreadArray(__spreadArray([], selections), [i]);
                }
            }
        });
        return __spreadArray(__spreadArray([], initialTreeArray), selections);
    };
    var _d = React.useState(getAllSelections()), selectedItems = _d[0], setSelectedItems = _d[1];
    var expandElementWithSelectedChildren = function (treeViewArray) {
        var newTree = treeViewArray.map(function (i) {
            // Requirement wants us to automatically expand the selected element that contains children. We only do this if the IsExpanded value is not set in the Data from props.
            if ((!i.IsExpanded) // If the IsExpanded is falsy, it means the user did not set it.
                && i.Children && i.Children.length > 0 && i.IsSelected) {
                return __assign(__assign({}, i), { IsExpanded: true, Children: expandElementWithSelectedChildren(i.Children) });
            }
            else {
                return i;
            }
        });
        return newTree;
    };
    var updateElement = function (element, isSelected) {
        var newChildren = [];
        // If the element is a folder and has children, tick/untick all children.
        var hasSelectedChildren = false;
        if (element.Folder && element.Children) {
            newChildren = element.Children.map(function (child) {
                return updateElement(child, isSelected); // Does recursion to update the child elements.
            });
            hasSelectedChildren = isSelected;
        }
        return __assign(__assign({}, element), { IsSelected: isSelected, HasSelectedChildren: hasSelectedChildren, Children: newChildren });
    };
    var updateArray = function (array, index, newValue) {
        return __spreadArray(__spreadArray(__spreadArray([], array.slice(0, index)), [
            newValue
        ]), array.slice(index + 1));
    };
    // This method searches the uniqueID from the specified tree, updates the item, then return the updated tree.
    var updateTreeviewArray = function (treeViewArray, idToReplace, newElement) {
        var updatedTreeviewArray = treeViewArray;
        var elementIndex = treeViewArray.findIndex(function (o) { return o.UniqueID === idToReplace; });
        if (elementIndex !== -1) {
            updatedTreeviewArray = updateArray(treeViewArray, elementIndex, newElement);
        }
        else { // If unable to findIndex, search from the Children.
            updatedTreeviewArray = treeViewArray.map(function (element) {
                var updatedElement = element;
                if (element.Children) {
                    updatedElement = __assign(__assign({}, element), { Children: updateTreeviewArray(element.Children, idToReplace, newElement) });
                }
                return updatedElement;
            });
        }
        return updatedTreeviewArray;
    };
    var updateParents = function (treeViewArray, element) {
        var updatedTreeviewArray = treeViewArray;
        if (element && element.ParentId) {
            // Find parent element.
            var parentElement = findElement(treeViewArray, element.ParentId);
            var hasSelectedChildren = false;
            var isParentSelected = false;
            if (parentElement && parentElement.Children) {
                var children = parentElement.Children;
                var selectedLength = children.filter(function (o) { return o.IsSelected; }).length;
                hasSelectedChildren = selectedLength > 0; // Show an indicator that means the parent has a selected children.
                isParentSelected = selectedLength === children.length; // Select the Parent if all children are selected.
            }
            var updatedParentElement = __assign(__assign({}, parentElement), { HasSelectedChildren: hasSelectedChildren, IsSelected: isParentSelected });
            updatedTreeviewArray = updateTreeviewArray(treeViewArray, element.ParentId, updatedParentElement);
            updatedTreeviewArray = updateParents(updatedTreeviewArray, parentElement); // This does recursion to update all the ancestors of this parent.
        }
        return updatedTreeviewArray;
    };
    React.useEffect(function () { return OnChange && OnChange(selectedItems); }, [selectedItems]);
    var onDataRequestHandler = function (item) { return null; };
    var filterTree = function (treeViewArray, searchText) {
        var filteredTreeArray = [];
        if (searchText === "") {
            filteredTreeArray = treeViewArray; // just show everything if empty string.
        }
        else {
            treeViewArray.forEach(function (element) {
                if (!element.Folder && element.Caption.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())) { // If the element is a leaf and matches the searchText, include it.
                    filteredTreeArray = __spreadArray(__spreadArray([], filteredTreeArray), [element]);
                }
                else if (element.Children) { // If the element is a folder and its children matches the searchText, include it. We do recursion in case the child is a folder.
                    var filteredChildren = filterTree(element.Children, searchText);
                    if (filteredChildren.length > 0) {
                        filteredTreeArray = __spreadArray(__spreadArray([], filteredTreeArray), [__assign(__assign({}, element), { Children: filteredChildren })]);
                    }
                    else if (element.Caption.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())) {
                        filteredTreeArray = __spreadArray(__spreadArray([], filteredTreeArray), [__assign(__assign({}, element), { Children: [] })]);
                    }
                }
            });
        }
        return filterReadOnly(filteredTreeArray);
    };
    var filterReadOnly = function (treeViewArray) {
        if (!IsSelectedOnlyMode) {
            return treeViewArray;
        }
        var selectedOnly = [];
        treeViewArray.forEach(function (e) {
            if (e.Folder) {
                var children = filterReadOnly(e.Children);
                if (children.length > 0) {
                    e.Children = children;
                    selectedOnly.push(e);
                }
            }
            else if (e.IsSelected) {
                selectedOnly.push(e);
            }
        });
        return selectedOnly;
    };
    var onClickElement = function (element) {
        // if there is a searchString, get the element from the mainTreeviewArray to get the unfiltered version of the element.
        var sElement = (searchString === "" ? element : findElement(mainTreeviewArray, element.UniqueID));
        // Update the selection of target element and children.
        var updatedTreeviewArray = updateTreeviewArray(mainTreeviewArray, element.UniqueID, updateElement(sElement, !sElement.IsSelected));
        // Update the selection/fill of the parent.
        updatedTreeviewArray = updateParents(updatedTreeviewArray, element);
        // Update the main TreeviewArray state.
        setMainTreeviewArray(updateHasSelectedChildren(updatedTreeviewArray));
        // Update the selected unique ids that will be returned to consumer of this component.
        setSelectedItems(getSelectionsFromTree(updatedTreeviewArray));
    };
    var handleOnSearch = function (searchStr) { return setSearchString(searchStr); };
    var isDeselectAll = function () { return selectedItems.length > 0; };
    var getDeselectOrSelectText = function () { return isDeselectAll() ? Localization_1.strings.SearchableTreeview_Action_DeselectAll : Localization_1.strings.SearchableTreeview_Action_SelectAll; };
    var onClickToggleDeselectOrSelectAll = function () {
        if (isDeselectAll()) {
            var updatedTreeviewArray = mainTreeviewArray.map(function (element) { return updateElement(element, false); });
            setMainTreeviewArray(updateHasSelectedChildren(updatedTreeviewArray));
            setSelectedItems(getSelectionsFromTree(updatedTreeviewArray));
        }
        else {
            var updatedTreeviewArray = mainTreeviewArray.map(function (element) { return updateElement(element, true); });
            setMainTreeviewArray(updateHasSelectedChildren(updatedTreeviewArray));
            setSelectedItems(getSelectionsFromTree(updatedTreeviewArray));
        }
    };
    var getTotalSelectText = function () { return Localization_1.strings.formatString(Localization_1.strings.SearchableTreeview_Label_ItemsSelected, selectedItems.length); };
    var handleOnBlur = function () {
        if (OnBlur) {
            OnBlur(selectedItems);
        }
    };
    return (React.createElement(SearchableTreeview_styles_1.Wrapper, null,
        React.createElement(SearchableTreeview_styles_1.TreeHeaderToolBarDiv, null,
            !IsSelectedOnlyMode && React.createElement(SearchableTreeview_styles_1.SearchableTreeviewSection, { tabIndex: 0, "aria-label": HeaderAriaLabel },
                React.createElement(Form_1.TextWithRequired, { LabelText: getTotalSelectText(), ShowRequiredIndicator: ShowRequired ? true : false })),
            !IsSelectedOnlyMode &&
                React.createElement(SearchableTreeview_styles_1.DeSelectOrSelectButton, { onBlur: handleOnBlur, "aria-label": getDeselectOrSelectText(), onClick: onClickToggleDeselectOrSelectAll }, getDeselectOrSelectText())),
        ErrorMessage && React.createElement(SearchableTreeview_styles_1.ErrorTextWrapperDiv, null,
            React.createElement(SearchableTreeview_styles_1.ErrorText, null, ErrorMessage)),
        !IsSelectedOnlyMode && React.createElement(Searcher_1.Searcher, { ref: inputControl, OnSearch: handleOnSearch, OnClear: function () { return setSearchString(""); }, InitialSearch: searchString, AriaLabel: SearchAriaLabel ? SearchAriaLabel : "", Placeholder: SearchPlaceholder ? SearchPlaceholder : "", MinimumCharactersToTrigger: 0, DebounceTimeout: 0 }),
        React.createElement("div", { onBlur: handleOnBlur },
            React.createElement(Lists_1.Treeview, { Data: filterTree(mainTreeviewArray, searchString), OnDataRequest: (onDataRequestHandler), IndentAmount: 22, RenderFolder: function (data) { return React.createElement(Element_1.Element, { Data: data, OnClickElement: onClickElement, IsReadOnly: IsSelectedOnlyMode, HighlightedString: searchString }); }, RenderItem: function (data, ref) { return React.createElement(Element_1.Element, { Data: data, OnClickElement: onClickElement, IsReadOnly: IsSelectedOnlyMode, ref: ref, HighlightedString: searchString }); } }))));
};
exports.SearchableTreeview = SearchableTreeview;
